import React from 'react';
import PropTypes from 'prop-types';
import { InView } from 'react-intersection-observer';

import { Grid } from 'components/Grid';
import { Link } from 'components/Link';
import { Text } from 'components/Text';
import { cx } from 'utility';
import * as styles from './TechList.module.scss';

const propTypes = {
    className: PropTypes.string,
    items: PropTypes.array,
};

const defaultProps = {
    className: '',
    items: [],
};

function getClasses({ className }) {
    const classes = cx(
        className,
        styles['techList'],
    );

    return classes || undefined;
}

function TechList({
    className,
    items,
}) {
    const classes = getClasses({ className });

    return (
        <div className={classes}>
            <Grid>
                <div className={styles['container']}>
                    {items.map(({ tech_category, tech_icon, tech_name, tech_url }, index) => {
                        const category = tech_category;
                        const icon = tech_icon;
                        const name = tech_name;

                        return (
                            <InView key={`faq-item-${index}`} threshold={0.1} triggerOnce={true}>
                                {({ inView, ref, entry }) => {
                                    return (
                                        <div className={cx(styles['itemWrapper'], (inView) && styles['inview'])} ref={ref}>
                                            <div className={styles['item']}>
                                                <div className={styles['iconContainer']}>
                                                    <div className={styles['icon']} dangerouslySetInnerHTML={{ __html: icon }}></div>
                                                </div>
                                                <div className={styles['contentContainer']}>
                                                    <Text
                                                        as="span"
                                                        className={styles['category']}
                                                        emphasis="low"
                                                        size={1}
                                                    >
                                                        {category}
                                                    </Text>
                                                    <Text
                                                        as="strong"
                                                        className={styles['name']}
                                                        emphasis="medium"
                                                        size={5}
                                                    >
                                                        <Link className={styles['nameLink']} emphasis="medium" to={tech_url}>{name}</Link>
                                                    </Text>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                }}
                            </InView>
                        );
                    })}
                </div>
            </Grid>
        </div>
    );
}

TechList.propTypes = propTypes;
TechList.defaultProps = defaultProps;

export { TechList };
